import * as React from 'react'

import { TNoColorSvgProps, TSvgProps } from '../Svg'

type TProps = NoChildren &
  TNoColorSvgProps & {
    /**
     * the color of the logo, *CSS `fill` of the `path` element*
     */
    fill?: TSvgProps['fill']
  }

/**
 * SVG speedlo logo `eɘ` with configurable attributes
 * mostly to be used in combination with `Svg` helper component
 */
export const SpeedloEe: React.FC<TProps> = ({
  fill,
  width = `100%`,
  height = `100%`,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 34.36 17.132902"
      width={width}
      height={height}
      {...props}
    >
      <path
        d="M59.19 22.94a9 9 0 01-7.66-3.81l3.46-2a5.29 5.29 0 004.2 1.87c.9 0 3.94-.3 4.48-3H38.2c.53 2.69 3.58 3 4.47 3a5.32 5.32 0 004.21-1.91l3.46 2a9 9 0 01-7.67 3.81c-3.19 0-8.92-1.82-8.92-8.56s5.85-8.53 8.92-8.53a8.32 8.32 0 018.26 6 8.33 8.33 0 018.26-6c3.08 0 8.92 1.79 8.92 8.53 0 6.74-5.72 8.56-8.92 8.56zM42.64 9.76a3.81 3.81 0 013.88 3.13h-8.2c.18-1.67 1.76-3.13 4.32-3.13zm16.58 0a3.82 3.82 0 00-3.88 3.13h8.21c-.18-1.67-1.76-3.13-4.33-3.13z"
        fill={fill}
        fillRule="evenodd"
        transform="translate(-33.75 -5.811)"
      />
    </svg>
  )
}
